// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b4687073","455":"1a340401","977":"7b9fab3f"}[chunkId] + ".chunk.js";
};